import React, { PropTypes } from 'react';
import * as pathConstants from '../../constants/pathConstants';
import * as formNames from '../../constants/formNameConstants';
import { Link } from 'react-router';

const BreadCrumb = ({ pageName, parent }) => {
  return (
    <div className="bread-crumb">
      {pageName && pageName !== formNames.itaHomePage && <span className="parent">
        {parent.name == formNames.itaDashboardPage && (
          <Link
            to={parent.link || pathConstants.pathToHome}
            name="breadcrumb-parent"
            id="breadcrumb-parent" title="Back to your Establishment List">
            {parent.name}
          </Link>
        )}
        {parent.name == formNames.establishmentViewPage && (
          <Link
            to={parent.link || pathConstants.pathToHome}
            name="breadcrumb-parent"
            id="breadcrumb-parent" title="Back to your Establishment List">
            {parent.name}
          </Link>
        )}
        {parent.name == formNames.itaHomePage && (
          <Link
            to={parent.link || pathConstants.pathToHome}
            name="breadcrumb-parent"
            id="breadcrumb-parent" title="Back to Injury Tracking Application Home">
            {parent.name}
          </Link>
        )}
        {parent.name == formNames.injuryReportingPage && (
          <a
            href={pathConstants.pathToInjuryReporting}
            name="breadcrumb-parent"
            id="breadcrumb-parent" title="Back to Injury Reporting">
            {parent.name}
          </a>
        )}
        {parent.name == formNames.caseDataDashboard && (
          <Link
            to={parent.link || pathConstants.pathToHome}
            name="breadcrumb-parent"
            id="breadcrumb-parent" title="Back to your 300/301 Case Data">
            {parent.name}
          </Link>
        )}
        {parent.name == formNames.itaLoginPage && (
          <Link
            to={parent.link || pathConstants.pathToHome}
            name="breadcrumb-parent"
            id="breadcrumb-parent" title="Back ITA Login page">
            {parent.name}
          </Link>
        )}
        { } / { }
      </span>}
      <span className="current">
        {pageName}
      </span>
    </div>
  );
};

BreadCrumb.propTypes = {
  pageName: PropTypes.string,
  parent: PropTypes.object.isRequired
};

export default BreadCrumb;



/** WEBPACK FOOTER **
 ** ./src/components/common/BreadCrumb.js
 **/